import React, { useContext, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Typography,
    TextField,
    TextareaAutosize,
} from '@material-ui/core';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import useSessionStore from '@services/stores/SessionStore';
import { useStyles } from '@pages/account/wishlists/create/index';
import { useTranslation } from '@tools/i18n';

export default function DateWishlistConfigurator({ currentSelected, onChange, onDateChange, onContinue, step }) {
    const classes = useStyles();
    const config = useSessionStore((state) => state.session.config);
    const { t } = useTranslation(['account']);


    return (
        <Box className={classes.wrapper} >
            <Typography variant="h6" className={classes.title}>
                {t('wishlist-wizard-standard-title')}
            </Typography>
            <TextField
                fullWidth
                label={t('wishlist-wizard-standard-title-input-label')}
                value={currentSelected.name}
                onChange={(e)=> onChange({ ...currentSelected, name: e.currentTarget.value})}
                variant="outlined"
                margin="normal"
                className={classes.input}
                placeholder={t('wishlist-wizard-standard-title-input-placeholder')}
                InputLabelProps={{ shrink: true }}
            />

            <div className={classes.datepickerWrapper}>
                <label className={classes.datepickerLabel} htmlFor={"react-date-picker-wishlist"}>
                    {t('wishlist-wizard-date-dateselect-label')}
                </label>
                <DatePicker
                    id={'react-date-picker-wishlist'}
                    className={classes.datepicker}
                    selected={currentSelected?.date ? new Date(currentSelected?.date) : new Date()}
                    placeholderText={'YYYY-MM-DD'}
                    onChange={(date) => onDateChange(date)}
                />
            </div>

            <Typography variant="subtitle1" className={classes.title}>
                {t('wishlist-wizard-standard-description-textarea-label')}
            </Typography>
            <TextareaAutosize
                className={[classes.textArea, classes.input].join(' ')}
                value={currentSelected.text}
                onChange={(e)=> onChange({ ...currentSelected, text: e.currentTarget.value})}
                placeholder={t('wishlist-wizard-standard-description-textarea-placeholder')}
            />

            <Button
                fullWidth
                className={classes.continueButton}
                onClick={onContinue}
                disabled={!currentSelected.name || !currentSelected.date}
            >
                {t('wishlist-wizard-create-button')}
            </Button>

        </Box>
    );
};